import { useCallback, useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import Grid from '@mui/material/Grid2';
import { Box, Button, Divider, Paper, Typography } from '@mui/material';
import { Settings } from '../../../interfaces/Settings/Settings';
import { getSettingsByType, upsertSettings } from '../../../api/Settings';
import { SettingsType } from '../../../interfaces/Settings/SettingsType';
import { GenericSettingsValue } from '../../../interfaces/Settings/GenericSettingsValue';
import { getSettingsValue, getUpdatedSettings } from '../../../utils/Settings';
import { Waiting } from '../../../components/Waiting/Waiting';
import { sharedStyles } from '../../../utils/Style';
import { SettingsRow } from '../../../components/Settings/SettingsRow';
import { SettingsValueType } from '../../../interfaces/Settings/SettingsValueType';

const socialMediaKeys = [
  'storefront_facebook_link',
  'storefront_twitter_link',
  'storefront_instagram_link',
  'storefront_youtube_link',
  'storefront_linkedin_link',
];

export const SocialMediaSettings = () => {
  const [settings, setSettings] = useState<Settings[]>([]);
  const [loading, setLoading] = useState(true);

  const refreshSettings = () => {
    setLoading(true);
    getSettingsByType(SettingsType.FRONTEND)
      .then((s) => setSettings(s))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshSettings();
  }, []);

  const handleChange = useCallback(
    (key: string, newValue: GenericSettingsValue) =>
      setSettings(
        getUpdatedSettings(SettingsType.FRONTEND, key, settings, newValue),
      ),
    [settings],
  );

  const handleSave = () => {
    setLoading(true);
    upsertSettings(settings.filter((s) => socialMediaKeys.includes(s.key)))
      .then(() => {
        toast.success('Ayarlar başarıyla kaydedildi');
        refreshSettings();
      })
      .catch((err) => {
        toast.error(err.message);
        setLoading(false);
      });
  };

  return (
    <Grid container spacing={2}>
      <Waiting open={loading} />
      <Grid size={{ xs: 12, xl: 6 }}>
        <Paper
          sx={{
            p: 1.5,
            display: 'flex',
            flexDirection: 'column',
            gap: 1.5,
            height: '95%',
          }}
        >
          <Typography
            sx={{
              ...sharedStyles.h5,
              fontWeight: 'bold',
            }}
          >
            Sosyal Medya Linkleri
          </Typography>
          <Divider />

          <SettingsRow
            name='Facebook'
            valueType={SettingsValueType.TEXT}
            value={getSettingsValue(settings, 'storefront_facebook_link')}
            onChange={(newValue) =>
              handleChange('storefront_facebook_link', newValue)
            }
          />
          <SettingsRow
            name='X'
            valueType={SettingsValueType.TEXT}
            value={getSettingsValue(settings, 'storefront_twitter_link')}
            onChange={(newValue) =>
              handleChange('storefront_twitter_link', newValue)
            }
          />
          <SettingsRow
            name='Instagram'
            valueType={SettingsValueType.TEXT}
            value={getSettingsValue(settings, 'storefront_instagram_link')}
            onChange={(newValue) =>
              handleChange('storefront_instagram_link', newValue)
            }
          />
          <SettingsRow
            name='Youtube'
            valueType={SettingsValueType.TEXT}
            value={getSettingsValue(settings, 'storefront_youtube_link')}
            onChange={(newValue) =>
              handleChange('storefront_youtube_link', newValue)
            }
          />
          <SettingsRow
            name='LinkedIn'
            valueType={SettingsValueType.TEXT}
            value={getSettingsValue(settings, 'storefront_linkedin_link')}
            onChange={(newValue) =>
              handleChange('storefront_linkedin_link', newValue)
            }
          />
          <Box sx={{ display: 'flex', flexGrow: 1 }} />
          <Box display='flex' justifyContent='flex-end'>
            <Button
              variant='contained'
              onClick={handleSave}
              sx={{ ...sharedStyles.buttonText, mt: 1.5 }}
            >
              Kaydet
            </Button>
          </Box>
        </Paper>
      </Grid>
    </Grid>
  );
};
